// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.company-intro__logo--white path {
    fill: white;
}

.company-intro__logo-bg--desktop {
    width: auto;
}

.company-intro__logo-bg--mobile {
    position: absolute;
    width: auto;
    height: auto;
    top: 15%;
}

.login-page__placeholder .company-intro__logo--white {
    display: none;
}

.notification-warning .labeled-text__primary {
    color: var(--app__secondary-text-color) !important;
}

.list-item-link__icon-text svg rect {
    fill: var(--app-fill-color-primary-one);
}

.main-action-btn__label-text {
    color: var(--app__action-submit-btn-color);
}

.login-form .app-logo {
    visibility: hidden !important;
}

.app-header__logo-container {
    justify-content: flex-start !important;
}

.app-header__logo {
    margin: unset !important;
}

.app-header {
    padding-bottom: 1rem !important;
    padding-left: 1.5rem !important;
}

.page-dashboard .page-content-wrapper {
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: stretch;
    gap: 1rem;
}

.page-dashboard .page-content-wrapper #dashboard-invoices-card {
    margin: 0 1rem;
}

.dashboard-area {
    padding: 0 !important;
}

.dashboard-notices-block .dashboard-area {
    padding: 1rem !important;
}

.dashboard-area {
    margin: 0 1rem;
}

.page-dashboard .app-header {
    height: 42px;
}

.app-header__logo-container {
    padding: 0 16px;
    box-sizing: border-box;
}

@media screen and (max-width: 460px){
    .larva-devices-widget {
        margin-left: -16px;
    }
}

.notification-area .dashboard-area {
    margin-top: 2rem;
}

@media screen and (min-width: 680px) {
    .page-dashboard .page-content-wrapper #dashboard-invoices-card {
        margin: 0;
    }

    .dashboard-area {
        margin: 0;
    }

    .page-dashboard .app-header {
        height: 40px;
        padding-left: 0 !important;
    }

    .app-header__logo-container picture {
        height: 40px !important;
    }

    .app-header__wrapper h2 {
        padding-left: 1rem !important;
    }

    .app-header .dashboard .page-content__app-header {
        margin-bottom: 1rem;
    }

    .app-header__logo-container {
        padding: 0;
    }
}

#inception-widget-dialog .MuiDialog-container {
    height: 100%;
}

#inception-widget-dialog .MuiDialog-paperScrollPaper {
    max-height: unset;
}

#inception-widget-dialog .MuiDialog-paper {
    height: 100%;
    margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/resources/vahi/addition.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,+BAA+B;IAC/B,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,wBAAwB;IACxB,uBAAuB;IACvB,oBAAoB;IACpB,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,SAAS;IACb;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,0BAA0B;IAC9B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,SAAS;AACb","sourcesContent":[".company-intro__logo--white path {\n    fill: white;\n}\n\n.company-intro__logo-bg--desktop {\n    width: auto;\n}\n\n.company-intro__logo-bg--mobile {\n    position: absolute;\n    width: auto;\n    height: auto;\n    top: 15%;\n}\n\n.login-page__placeholder .company-intro__logo--white {\n    display: none;\n}\n\n.notification-warning .labeled-text__primary {\n    color: var(--app__secondary-text-color) !important;\n}\n\n.list-item-link__icon-text svg rect {\n    fill: var(--app-fill-color-primary-one);\n}\n\n.main-action-btn__label-text {\n    color: var(--app__action-submit-btn-color);\n}\n\n.login-form .app-logo {\n    visibility: hidden !important;\n}\n\n.app-header__logo-container {\n    justify-content: flex-start !important;\n}\n\n.app-header__logo {\n    margin: unset !important;\n}\n\n.app-header {\n    padding-bottom: 1rem !important;\n    padding-left: 1.5rem !important;\n}\n\n.page-dashboard .page-content-wrapper {\n    display: flex;\n    flex-flow: column nowrap;\n    justify-content: center;\n    align-items: stretch;\n    gap: 1rem;\n}\n\n.page-dashboard .page-content-wrapper #dashboard-invoices-card {\n    margin: 0 1rem;\n}\n\n.dashboard-area {\n    padding: 0 !important;\n}\n\n.dashboard-notices-block .dashboard-area {\n    padding: 1rem !important;\n}\n\n.dashboard-area {\n    margin: 0 1rem;\n}\n\n.page-dashboard .app-header {\n    height: 42px;\n}\n\n.app-header__logo-container {\n    padding: 0 16px;\n    box-sizing: border-box;\n}\n\n@media screen and (max-width: 460px){\n    .larva-devices-widget {\n        margin-left: -16px;\n    }\n}\n\n.notification-area .dashboard-area {\n    margin-top: 2rem;\n}\n\n@media screen and (min-width: 680px) {\n    .page-dashboard .page-content-wrapper #dashboard-invoices-card {\n        margin: 0;\n    }\n\n    .dashboard-area {\n        margin: 0;\n    }\n\n    .page-dashboard .app-header {\n        height: 40px;\n        padding-left: 0 !important;\n    }\n\n    .app-header__logo-container picture {\n        height: 40px !important;\n    }\n\n    .app-header__wrapper h2 {\n        padding-left: 1rem !important;\n    }\n\n    .app-header .dashboard .page-content__app-header {\n        margin-bottom: 1rem;\n    }\n\n    .app-header__logo-container {\n        padding: 0;\n    }\n}\n\n#inception-widget-dialog .MuiDialog-container {\n    height: 100%;\n}\n\n#inception-widget-dialog .MuiDialog-paperScrollPaper {\n    max-height: unset;\n}\n\n#inception-widget-dialog .MuiDialog-paper {\n    height: 100%;\n    margin: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
